require('webpack-jquery-ui/slider');
require('webpack-jquery-ui/slide-effect');
require('../../scss/jq_ui_style/jquery-ui.theme.css');

// 價格篩選
$("#price_filter_range").slider({
    range: true,
    min: 0,
    max: 500,
    values: [0, 500],
    slide: function (event, ui) {
        $("#price_range").val(`價格介於 NT ${ui.values[0]} 至 NT ${ui.values[1]} `);
    }
});
$("#price_range").val(`價格介於 NT ${$("#price_filter_range").slider("values", 0)} 至 NT ${$("#price_filter_range").slider("values", 1)} `);


// event：
// ================================================================================================
$('.product_list_card_pic').on('mouseenter', function (event) {
    $(this).parents('.product_list_card').find('.hover_icon').css({ 'transform': 'translate(0%,-150%)' });
    $('.product_list_card_pic').on('mouseleave', function (event) {
        $(this).parents('.product_list_card').find('.hover_icon').css({ 'transform': 'translate(0%,0%)' });
    });
});

$('.hover_icon.hover_icon_addFavorite').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-bookmark-heart').addClass('bi-bookmark-heart-fill');
    $('.hover_icon_addFavorite').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-bookmark-heart-fill').addClass('bi-bookmark-heart');
    });
});

$('.hover_icon.hover_icon_addCart').on('mouseenter', function (event) {
    $(this).find('i').removeClass('bi-cart-plus').addClass('bi-cart-plus-fill');
    $('.hover_icon_addCart').on('mouseleave', function (event) {
        $(this).find('i').removeClass('bi-cart-plus-fill').addClass('bi-cart-plus');
    });
});



